EventEmitter = require('events').EventEmitter

bus = new EventEmitter()
bus.events = {
  CONFIG_CHANGED: 'configChanged'
}

module.exports = bus
